/* Native links, details and document flow remain usable without this enhancement. */
(() => {
  function initialize(root) {
    if (root.dataset.journalReady) return;
    root.dataset.journalReady = 'true';
    const body = root.querySelector('[data-journal-body]');
    if (!body) return;
    const toc = root.querySelector('[data-journal-toc]');
    const list = root.querySelector('[data-journal-toc-list]');
    const title = root.querySelector('h1');
    body.querySelectorAll('h2').forEach(heading => {
      if (heading.textContent.trim().toLowerCase() === title?.textContent.trim().toLowerCase()) {
        // Keep incoming fragment links pointing to the title after removing the duplicate.
        if (heading.id && !title.id) { title.id = heading.id; heading.removeAttribute('id'); }
        heading.hidden = true;
      }
    });
    const headings = [...body.querySelectorAll('h2')].filter(h => !h.hidden && h.textContent.trim() && !h.closest('[data-joyo-cta], .joyo3-cta, .joyo3-trust'));
    // Reserve all existing IDs, including headings not included in the table of contents.
    const used = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
    const entries = [];
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').slice(0, 70) || 'section';
        let id = base, suffix = 2;
        while (used.has(id)) id = `${base}-${suffix++}`;
        heading.id = id; used.add(id);
      }
      const item = document.createElement('li'), link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`; link.textContent = heading.textContent.trim();
      item.append(link); list?.append(item); entries.push({ heading, link });
    });
    if (entries.length && toc) {
      const desktop = window.matchMedia('(min-width: 1100px)');
      toc.hidden = false;
      toc.open = desktop.matches;
      // Keep navigation appropriate when the viewport crosses the reading breakpoint.
      desktop.addEventListener('change', event => { toc.open = event.matches; });
    }
    if (entries.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(items => {
        const visible = items.filter(item => item.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        entries.forEach(({ heading, link }) => {
          if (heading === visible[0].target) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-120px 0px -55% 0px', threshold: 0 });
      entries.forEach(({ heading }) => observer.observe(heading));
    }
    body.querySelectorAll('table').forEach((table, index) => {
      if (table.parentElement.classList.contains('journal-table')) return;
      const scroll = document.createElement('div');
      scroll.className = 'journal-table'; scroll.tabIndex = 0; scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', `${body.dataset.tableLabel} ${index + 1}`);
      table.before(scroll); scroll.append(table);
      const hint = document.createElement('p'); hint.className = 'journal-table-hint'; hint.textContent = body.dataset.tableHint;
      scroll.prepend(hint);
    });
  }
  document.querySelectorAll('[data-journal-article]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-journal-article]').forEach(initialize));
})();
